// Swiper is imported already
class productDetailSwiper extends HTMLElement {
  constructor() {
    super();

    this.swiperElement = this.querySelector('[data-product-detail-swiper]');

    this.swiperOptions = {
      direction: 'horizontal',
    };

    this.init();
  }

  init() {
    window.addEventListener('load', (event) => {
      this.swiperInstance = new Swiper(this.swiperElement, this.swiperOptions);
    });
    Fancybox.bind('[data-fancybox]', {
      animated: false,
      showClass: false,
    });
  }
}

if (!customElements.get('product-detail-swiper')) {
  customElements.define('product-detail-swiper', productDetailSwiper);
}

class productInfo extends HTMLElement {
  constructor() {
    super();
    let stillAbleToAdd = true;
    this.productWrapper = document.querySelector('.product-wrapper');
    this.stickyAtc = this.querySelector('sticky-atc');
    this.productForm = this.querySelector('product-form');
    const productId = parseInt(this.querySelector('[data-productid]').dataset.productid);
    this.productFormQuantity = this.productForm?.querySelector('input[name="quantity"]');
    this.quantityInput = this.querySelector('quantity-input');
    this.quantityInputElement = this.quantityInput?.querySelector('input[name="quantity"]');
    const maxOrder = parseInt(this.querySelector('[data-max-order]').value);
    const submitButton = this.querySelector('[type="submit"]');
    this.buttonPrice = this.querySelector('[data-variant-price]');
    this.variants_selector = this.querySelector('.product__variant-selector');
    this.rechargeSubscriptionWidget = document.querySelector('.recharge-subscription-widget');

    this.quantityInputElement?.addEventListener('change', () => {
      this.handleQuantityInput();
    });

    if (this.stickyAtc) {
      this.stickyAtcObserver();
    }

    // Find recharge subscription widget

    if (this.rechargeSubscriptionWidget && this.rechargeSubscriptionWidget !== null && this.rechargeSubscriptionWidget !== undefined) {
      this.rechargeInterval();
    }

    // On variant change, re-find recharge subscription widget
    if (this.variants_selector) {
      if (this.variants_selector.classList.contains('product__variant-selector--buttons')) {
        this.variants = this.variants_selector.querySelectorAll('.options__input');
      } else if (this.variants_selector.classList.contains('product__variant-selector--select')) {
        this.variants = this.variants_selector.querySelectorAll('.field__select');
      }

      this.variants.forEach((variant) => {
        variant?.addEventListener('change', () => {
          if (this.rechargeSubscriptionWidget) {
            this.rechargeInterval();
          }
          const config = fetchConfig('javascript');
          config.headers['X-Requested-With'] = 'XMLHttpRequest';
          delete config.headers['Content-Type'];

          fetch(`${routes.cart_url}`, config)
            .then((response) => response.json())
            .then((response) => {
              const cartItems = response.items;
              cartItems.filter(function (item, index) {
                if (item.product_id === productId) {
                  let itemQuantity = parseInt(item.quantity);
                  // check cart item quantity v.s. max order quantity
                  if (maxOrder && maxOrder > 0 && maxOrder !== null && maxOrder !== undefined) {
                    if (itemQuantity > maxOrder) {
                      submitButton.setAttribute('disabled', true);
                      stillAbleToAdd = false;
                    } else {
                      submitButton.removeAttribute('disabled');
                      stillAbleToAdd = true;
                    }
                  } else {
                    submitButton.removeAttribute('disabled');
                    stillAbleToAdd = true;
                  }
                }
              });
            });
        });
      });
    }
  }

  rechargeInterval() {
    const rechargeInterval = setInterval(() => {
      if (!this.querySelector('.rc-widget')) {
        return;
      } else {
        clearInterval(rechargeInterval);
        this.UpdateRecharge();
        this.catchClickRecharge();
        this.UpdatePrice();
      }
    }, 100);
  }

  /**
   * catchClickRecharge
   * @description if recharge subscription widget, catch click on radio's.
   */
  catchClickRecharge() {
    this.rechargeWidget = this.querySelector('.rc-widget');
    this.rechargeSubscriptionRadio = this.rechargeWidget.querySelector('.subscription-radio');
    this.rechargeOneTimeRadio = this.rechargeWidget.querySelector('.onetime-radio');
    //Update variant price on click widget options if there is a recharge widget

    //if there is a subscription option
    if (this.rechargeSubscriptionRadio) {
      this.subscriptionInput = this.rechargeOneTimeRadio.querySelector('input');
      //bind event listener for radio button and input click
      this.rechargeSubscriptionRadio.addEventListener('click', () => {
        this.handleRecharge();
      });
      if (this.subscriptionInput) {
        this.subscriptionInput.addEventListener('click', () => {
          this.handleRecharge();
        });
      }
    }

    // If there is a one time option
    if (this.rechargeOneTimeRadio) {
      // only if the subscription is checked the price will be updated op page load
      this.oneTimeInput = this.rechargeOneTimeRadio.querySelector('input');

      //bind event listener for radio button and input click
      this.rechargeOneTimeRadio.addEventListener('click', () => {
        this.handleRecharge();
      });
      if (this.oneTimeInput) {
        this.oneTimeInput.addEventListener('click', () => {
          this.handleRecharge();
        });
      }
    }
  }

  /**
   * UpdateRecharge
   * @description Update recharge subscription widget.
   */
  UpdateRecharge() {
    this.rechargeWidgetWrapper = document.querySelector('[data-subscription-first-usp]');
    this.rechargeWidget = this.querySelector('.rc-widget');

    // If there is a recharge widget
    if (this.rechargeWidget) {
      this.UpdateSubscriptionLabel();
      this.handleRecharge();
    }
  }

  /**
   * UpdatePrice
   * @description Update button price from recharge subscription widget.
   */
  UpdatePrice() {
    this.rechargeSubscriptionRadio = this.rechargeWidget.querySelector('.subscription-radio');
    this.rechargeOneTimeRadio = this.rechargeWidget.querySelector('.onetime-radio');

    if (this.buttonPrice) {
      if (this.rechargeSubscriptionRadio) {
        const subscriptionInput = this.rechargeSubscriptionRadio.querySelector(
          'input[value="subscription"]'
        );

        if (subscriptionInput.checked) {
          var price = this.rechargeSubscriptionRadio.querySelector('.rc-radio__price').textContent;
          this.buttonPrice.innerHTML = price;
        }
      }

      if (this.rechargeOneTimeRadio) {
        const oneTimeInput = this.rechargeWidget.querySelector('input[value="onetime"]');

        if (oneTimeInput.checked) {
          var priceWrapper = document.querySelector('product-info .product__price .price');

          let price = '';
          if (priceWrapper.classList.contains('price--on-sale')) {
            price = priceWrapper.querySelector('.price-item--sale').textContent;
          } else {
            price = priceWrapper.querySelector('.price-item--regular').textContent;
          }

          this.buttonPrice.innerHTML = price;
        }
      }
    }
  }

  /**
   * UpdateSubscriptionLabel
   * @description Replace the subscription option label from the recharge subscription widget.
   */
  UpdateSubscriptionLabel() {
    // Replace subscription label if set
    this.rechargeSubscriptionRadioLabel =
      this.rechargeWidget.querySelector('.rc-radio__subscription');
    if (this.rechargeSubscriptionRadioLabel) {
      const subscriptionLabel = this.rechargeWidgetWrapper.dataset.subscriptionLabel;
      if (subscriptionLabel) {
        this.rechargeSubscriptionRadioLabel.innerHTML = subscriptionLabel;
      }
    }
  }

  /**
   * handleRecharge
   * @description Add USPs to the recharge subscription widget.
   */
  handleRecharge() {
    this.rechargeWidget = document.querySelector('.rc-widget');
    if (this.rechargeWidget) {
      this.UpdatePrice();

      let sellingPlans = this.rechargeWidget.querySelector('.rc-selling-plans');
      if (sellingPlans) {
        this.addUSPS();
      }
      if (!sellingPlans) {
        setTimeout(() => {
          sellingPlans = this.rechargeWidget.querySelector('.rc-selling-plans');
          if (sellingPlans) {
            this.addUSPS();
          }
        }, 300);
      }
    }
  }

  /**
   * addUSPS
   * @description Add USPs to the recharge subscription widget.
   */
  addUSPS() {
    this.rechargeWidgetWrapper = document.querySelector('[data-subscription-first-usp]');

    const usp_1 = this.rechargeWidgetWrapper.dataset.subscriptionFirstUsp;
    const usp_2 = this.rechargeWidgetWrapper.dataset.subscriptionSecondUsp;
    const usp_3 = this.rechargeWidgetWrapper.dataset.subscriptionThirdUsp;

    let sellingPlans = this.rechargeWidget.querySelector('.rc-selling-plans');

    if (sellingPlans) {
      sellingPlans.insertAdjacentHTML(
        'beforeend',
        "<div class='sellingplan-usp-wrapper'><ul class='sellingplan-usps'></ul></div>"
      );

      const usps = this.rechargeWidget.querySelector('.sellingplan-usps');
      if (usps) {
        if (usp_1 && usp_2 && usp_3) {
          usps.innerHTML = '<li>' + usp_1 + '</li><li>' + usp_2 + '</li><li>' + usp_3 + '</li>';
        } else if (usp_1 && usp_2) {
          usps.innerHTML = '<li>' + usp_1 + '</li><li>' + usp_2 + '</li>';
        } else if (usp_1 && usp_3) {
          usps.innerHTML = '<li>' + usp_1 + '</li><li>' + usp_3 + '</li>';
        } else if (usp_2 && usp_3) {
          usps.innerHTML = '<li>' + usp_2 + '</li><li>' + usp_3 + '</li>';
        } else if (usp_1) {
          usps.innerHTML = '<li>' + usp_1 + '</li>';
        } else if (usp_2) {
          usps.innerHTML = '<li>' + usp_2 + '</li>';
        } else if (usp_3) {
          usps.innerHTML = '<li>' + usp_3 + '</li>';
        }
      }
    }
  }

  /* stickyAddToCart */
  stickyAtcObserver() {
    window.addEventListener("scroll", () => {
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const productWrapperBottom = this.productWrapper.offsetHeight;
      if (scrollTop > productWrapperBottom) {
        this.stickyAtc.classList.add("hide");
        setTimeout(() => {
          this.stickyAtc.classList.add("is-sticky");
        }, 300);
        setTimeout(() => {
          this.stickyAtc.classList.add("show");
        }, 500);
      } else {
        this.stickyAtc.classList.remove("show");
        setTimeout(() => {
          this.stickyAtc.classList.remove("is-sticky");
        }, 300);
        setTimeout(() => {
          this.stickyAtc.classList.remove("hide");
        }, 500);
      }
    });
  }

  /**
   * handleQuantityInput
   * @description Set the quantity from the quantity input web component to the product form web component.
   */
  handleQuantityInput() {
    this.productFormQuantity.value = this.quantityInputElement.value;
  }
}

if (!customElements.get('product-info')) {
  customElements.define('product-info', productInfo);
}
